import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CustomTreeTable from '../../components/Shared/CustomTreeTable'

const CustomBalanceSheetTreeTable = ({ data, language = 'en' }) => {
  const { t } = useTranslation()

  const transformedData = useMemo(() => {
    const transform = (nodes, level = 0) => {
      if (!Array.isArray(nodes)) return []
      return nodes.map((node) => ({
        key: node.key,
        data: {
          ...node,
          level,
          name_code: `${node.account_name || ''}-${node.account_code || ''}`,
        },
        children: transform(node.children, level + 1),
      }))
    }

    return transform(data?.data?.Assets?.Accounts || [])
  }, [data])

  const columns = [
    {
      field: 'name_code',
      header: t('name'),
      expander: true,
      body: (rowData) => <span>{rowData.data.name_code}</span>,
      style: { width: '40%' },
    },
    {
      field: 'total_credit',
      header: t('credit'),
      body: (rowData) => (
        <div className='a_credit'>
          {rowData.data.total_credit}
          <span> {t('SAR')}</span>
        </div>
      ),
      style: { width: '20%' },
    },
    {
      field: 'total_debit',
      header: t('debit'),
      body: (rowData) => (
        <div className='a_debit'>
          {rowData.data.total_debit}
          <span> {t('SAR')}</span>
        </div>
      ),
      style: { width: '20%' },
    },
    {
      field: 'balance',
      header: t('balance'),
      body: (rowData) => (
        <div className='a_balance'>
          {rowData.data.balance ? rowData.data.balance.toFixed(2) : '0'}{' '}
          <span>{t('SAR')}</span>
        </div>
      ),
      style: { width: '20%' },
    },
  ]

  return (
    <>
      <div className='py-2 text-xl font-semibold hidden'>1 - {t('assets')}</div>
      <div className=''>
        <CustomTreeTable
          data={transformedData}
          columns={columns}
          paginator={false}
          rowClassName={(node) => (node.data.level === 0 ? 'font-medium' : '')}
        />
      </div>
    </>
  )
}

export default CustomBalanceSheetTreeTable
